export enum ActionType {
    DEPOSIT = "deposit",
    WITHDRAW = "withdraw",
    BANKRUPT = "bankrupt",
    ADD_ACTIVITIES = "ADD_ACTIVITIES",
    SET_ACTIVITIES = "SET_ACTIVITIES",
    SET_SELECTED_ACTIVITY = "SET_SELECTED_ACTIVITY"
}